import type { dynamicObj } from 'src/pages/assets';
import { AMOUNT_COLUMNS } from 'src/pages/PurchaseOrders/constants.js';

export default {
  methods: {
    getColumnOrigin(table: dynamicObj, column_name: string) {
      let column_origin = 'auto';
      try {
        if (table?.formatting_options?.column_origins?.hasOwnProperty(column_name)) {
          column_origin = table.formatting_options.column_origins[column_name];
        }
      } catch (error) {
        logError(error);
      }
      return column_origin;
    },
    getExtractOrigin(table: dynamicObj, column_name: string) {
      let extract_origin = '';
      try {
        if (table?.formatting_options?.extract_from?.hasOwnProperty(column_name)) {
          extract_origin = table.formatting_options.extract_from[column_name];
        }
      } catch (error) {
        logError(error);
      }
      return extract_origin;
    },
    checkIfColumnIsAmount(columnName: string, amountColumns: any) {
      let isAmount = false;
      if (amountColumns.includes(columnName.toLowerCase())) {
        isAmount = true;
      }
      return isAmount;
    },
    customSort(rows: any, sortBy: string, descending: boolean): any {
      const data = [...rows] as any;

      // Return empty array if no data to sort
      if (!data || data.length === 0) {
        return data;
      }

      let columnName = sortBy + '_value';

      if (!data[0].hasOwnProperty(columnName)) {
        columnName = sortBy;
      }

      if (sortBy) {
        data.sort((a: any, b: any) => {
          const x = descending ? b : a;
          const y = descending ? a : b;

          if (this.checkIfColumnIsAmount(sortBy, AMOUNT_COLUMNS)) {
            // numeric sort
            return parseFloat(x[columnName]) - parseFloat(y[columnName]);
          } else {
            // string sort
            return x[sortBy] > y[sortBy] ? 1 : x[sortBy] < y[sortBy] ? -1 : 0;
          }
        });
      }

      return data;
    },
  },
};
